__turbopack_context__.v({
  "button": "dynamicForm-module-scss-module__x_cuCa__button",
  "checkboxes_wrap": "dynamicForm-module-scss-module__x_cuCa__checkboxes_wrap",
  "copy": "dynamicForm-module-scss-module__x_cuCa__copy",
  "dropdown": "dynamicForm-module-scss-module__x_cuCa__dropdown",
  "error": "dynamicForm-module-scss-module__x_cuCa__error",
  "field": "dynamicForm-module-scss-module__x_cuCa__field",
  "field_inner": "dynamicForm-module-scss-module__x_cuCa__field_inner",
  "form": "dynamicForm-module-scss-module__x_cuCa__form",
  "form_inner": "dynamicForm-module-scss-module__x_cuCa__form_inner",
  "form_wrapper": "dynamicForm-module-scss-module__x_cuCa__form_wrapper",
  "input": "dynamicForm-module-scss-module__x_cuCa__input",
  "input_wrap": "dynamicForm-module-scss-module__x_cuCa__input_wrap",
  "label": "dynamicForm-module-scss-module__x_cuCa__label",
  "option": "dynamicForm-module-scss-module__x_cuCa__option",
  "option_text": "dynamicForm-module-scss-module__x_cuCa__option_text",
  "submit_row": "dynamicForm-module-scss-module__x_cuCa__submit_row",
  "textarea": "dynamicForm-module-scss-module__x_cuCa__textarea",
  "turnstile": "dynamicForm-module-scss-module__x_cuCa__turnstile",
  "turnstileInteractive": "dynamicForm-module-scss-module__x_cuCa__turnstileInteractive",
  "wrapper": "dynamicForm-module-scss-module__x_cuCa__wrapper",
});
